import { render } from "./BookedArea.vue?vue&type=template&id=54c42deb"
import script from "./BookedArea.vue?vue&type=script&lang=js"
export * from "./BookedArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__